import API from '../../api/api';
import axios from 'axios';

function saveCookie(value, apiPath) {
    API.getAxios(apiPath).get(`/saveAdtractionCookie?at_gd=${value}`, {responseType: 'text'})
        .then(response => {
            console.log('Adtraction cookie written', response);
        })
        .catch(error => {
            console.log('Adtraction writing failed', error);
        })
}

function getCookie(apiPath) {
    return new Promise(resolve => {
        API.getAxios(apiPath).get('/getAdtractionCookie')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                console.log('Error in getting cookie', error);
            })
    })
}

function trackCookie(idPratica, cookieValue) {
    axios({
        method: 'get',
        url: `https://cnv.adt623.net/t/t?t=4&tk=1&am=0&c=EUR&ti=${idPratica}&tp=1838663940&trt=4&ss=1&ap=1838663192&at_gd=${cookieValue}`
    }).then(response => {
        console.log('Cookie tracked', response);
    }).catch(error => {
        console.log('Cookie track failed', error);
    })
}

export { saveCookie, getCookie, trackCookie }